<template>
    <div class="redpacket-pane">
        <!-- 创建红包 -->
        <el-card shadow="never" class="mb12">
            <div slot="header" class="card-title">发红包（创建 → 待发放 → 发放/撤回）</div>

            <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small" inline>
                <el-form-item label="直播间ID" prop="room_id">
                    <el-input-number v-model="form.room_id" :min="1" controls-position="right" />
                </el-form-item>

                <el-form-item label="类型" prop="type">
                    <el-select v-model="form.type" style="width: 140px">
                        <el-option :value="1" label="普通红包" />
                        <el-option :value="2" label="拼手气红包" />
                    </el-select>
                </el-form-item>

                <el-form-item label="总金额" prop="total_amount">
                    <el-input-number v-model="form.total_amount" :min="0.01" :step="10" :precision="2"
                        controls-position="right" />
                </el-form-item>

                <el-form-item label="总数量" prop="total_count">
                    <el-input-number v-model="form.total_count" :min="1" :step="1" controls-position="right" />
                </el-form-item>

                <el-form-item label="过期(分钟)" prop="expire_minutes">
                    <el-input-number v-model="form.expire_minutes" :min="1" :step="30" controls-position="right" />
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="creating" @click="onCreate">创建红包</el-button>
                    <el-button @click="resetForm">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- <el-alert class="mt8" type="info" show-icon :closable="false"
                title="提示：创建成功后会生成 red_packet_id；只有“待发放”状态才显示【发放】按钮。" /> -->
        </el-card>

        <!-- 列表 -->
        <el-card shadow="never">
            <div slot="header" class="card-title">
                红包列表
                <span style="float:right;">
                    <el-button size="mini" @click="fetchList">刷新</el-button>
                </span>
            </div>

            <div class="toolbar">
                <el-input v-model="query.red_packet_id" placeholder="按红包ID过滤" clearable size="small"
                    style="width: 220px;" @keyup.enter.native="fetchList" />
                <el-button size="small" style="margin-left:8px;" @click="fetchList">查询</el-button>
            </div>

            <el-table :data="list" border v-loading="loading" size="mini">
                <el-table-column prop="stream_id" label="直播间id" width="100" />
                <el-table-column prop="type" label="类型" width="100">
                    <template slot-scope="{row}">
                        {{ row.type === 2 ? '拼手气' : '普通' }}
                    </template>
                </el-table-column>
                <el-table-column prop="total_amount" label="总额" width="110">
                    <template slot-scope="{row}">{{ fmtMoney(row.total_amount) }}</template>
                </el-table-column>
                <el-table-column prop="total_count" label="总数" width="80" />
                <el-table-column prop="remaining_count" label="剩余" width="80" />
                <el-table-column prop="expire_minutes" label="过期(分)" width="95" />
                <el-table-column prop="status" label="状态" width="110">
                    <template slot-scope="{row}">
                        <el-tag :type="statusTag(row)">{{ statusText(row) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" min-width="160" />

                <el-table-column label="操作" width="240" fixed="right">
                    <template slot-scope="{row}">
                        <el-button type="text" size="mini" @click="openDetail(row.id)" v-if="row.expire_time">详情</el-button>

                        <el-button v-if="canGiveOut(row)" type="text" size="mini" :loading="row._giving"
                            @click="giveOut(row)">发放</el-button>

                        <el-button v-if="canRevoke(row)" type="text" size="mini" :loading="row._revoking"
                            @click="revoke(row)">撤回</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, ->, total" :current-page.sync="page"
                    :page-size="perPage" :total="total" @current-change="fetchList" />
            <!-- 详情弹窗 -->
            <el-dialog title="红包详情（领取明细）" :visible.sync="detailVisible" width="820px">
                <div v-if="detailHeader" class="detail-header">
                    <span>红包ID：<b>{{ detailHeader.red_packet_id }}</b></span>
                    <span style="margin-left:14px;">总额：<b>{{ fmtMoney(detailHeader.total_amount) }}</b></span>
                    <span style="margin-left:14px;">总数：<b>{{ detailHeader.total_count }}</b></span>
                    <span style="margin-left:14px;">剩余：<b>{{ detailHeader.remain_count }}</b></span>
                </div>

                <el-table :data="detailList" border size="mini" v-loading="detailLoading" style="margin-top:10px;">
                    <el-table-column prop="id" label="明细ID" width="90" />
                    <el-table-column prop="item_amount" label="单个金额" width="110">
                        <template slot-scope="{row}">{{ fmtMoney(row.item_amount) }}</template>
                    </el-table-column>
                    <el-table-column prop="status" label="领取状态" width="110">
                        <template slot-scope="{row}">
                            <el-tag :type="itemStatusTag(row.status)">{{ itemStatusText(row.status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_nickname" label="昵称" width="140" />
                    <el-table-column prop="user_phone" label="手机号" width="140" />
                    <el-table-column prop="receive_time" label="领取时间" width="170" />
                    <el-table-column prop="create_time" label="创建时间" width="170" />
                </el-table>

                <span slot="footer">
                    <el-button @click="detailVisible = false">关闭</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
import {
    createRedPacket,
    giveOutRedPacket,
    revokeRedPacket,
    listRedPackets,
    redPacketDetail
} from '@/api/index' // 你的 index.js 路径按实际调整

export default {
    name: 'RedPacketPane',
    props: {
        roomId: { type: [String, Number], default: '' },
        appid: { type: Number, default: 1 }
    },
    data() {
        return {
            creating: false,
            loading: false,
            list: [],
            query: { red_packet_id: '' },

            detailVisible: false,
            detailLoading: false,
            detailHeader: null,
            detailList: [],

            form: {
                appid: 1,
                room_id: null,
                type: 2,
                total_amount: 60,
                total_count: 3,
                expire_minutes: 480
            },
            rules: {
                room_id: [{ required: true, message: '请输入直播间ID', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'change' }],
                total_amount: [{ required: true, message: '请输入总金额', trigger: 'blur' }],
                total_count: [{ required: true, message: '请输入总数量', trigger: 'blur' }],
                expire_minutes: [{ required: true, message: '请输入过期分钟数', trigger: 'blur' }]
            },
            total:0,
            page:1,
            perPage:10
        }
    },
    watch: {
        roomId: {
            immediate: true,
            handler(v) {
                this.form.room_id = v ? Number(v) : null
                this.fetchList()
            }
        },
        appid: {
            immediate: true,
            handler(v) {
                this.form.appid = Number(v || 1)
            }
        }
    },
    methods: {
        fmtMoney(v) {
            const n = Number(v || 0)
            return n.toFixed(2)
        },

        resetForm() {
            this.$refs.form && this.$refs.form.resetFields()
            this.form.room_id = this.roomId ? Number(this.roomId) : null
            this.form.appid = this.appid
        },

        // 创建红包
        onCreate() {
            this.$refs.form.validate(async (ok) => {
                if (!ok) return
                this.creating = true
                try {
                    const payload = {
                        appid: Number(this.appid),
                        room_id: Number(this.form.room_id),
                        type: Number(this.form.type),
                        total_amount: Number(this.form.total_amount),
                        total_count: Number(this.form.total_count),
                        expire_minutes: Number(this.form.expire_minutes)
                    }
                    const res = await createRedPacket(payload)
                    // res 已经是 streamer 拦截器处理过的：成功时 res.code===0 返回 res（或你那边返回结构）
                    const data = res.data || res
                    this.$message.success(`创建成功：红包ID ${data.red_packet_id}`)
                    await this.fetchList()
                } catch (e) {
                    this.$message.error(e.message || '创建失败')
                } finally {
                    this.creating = false
                }
            })
        },

        // 列表
        async fetchList() {
            this.loading = true
            try {
                const params = {
                    room_id: this.roomId ? Number(this.roomId) : undefined,
                    red_packet_id: this.query.red_packet_id || undefined
                }
                const res = await listRedPackets(params)
                const data = res.data.data || res
                const arr = Array.isArray(data) ? data : (data && (data.list || data.rows)) || []
                this.list = arr.map(x => ({ ...x, _giving: false, _revoking: false }))
                this.total = res.data.total
                this.page += 1
            } catch (e) {
                this.$message.error(e.message || '获取列表失败')
            } finally {
                this.loading = false
            }
        },

        // 状态展示（list 返回没在 txt 给示例，这里做兼容）
        statusText(row) {
            const s = row.status
            if (s === 0) return '待发放'
            if (s === 1) return '发放中'
            if (s === 2) return '已领完'
            if (s === 3) return '已过期'
            if (s === 4) return '已撤回'
            if (s === 5) return '扣款失败'
            return row.status_text || row.statusText || '未知'
        },
        statusTag(row) {
            const s = row.status
            if (s === 0) return 'warning'
            if (s === 1 || s === 2) return 'success'
            if (s === 3 || s === 4) return 'info'
            if (s === 5) return 'error'
            return ''
        },
        canGiveOut(row) {
            // “只有待发放的请求下才有次按钮”
            return row.status === 0 || row.status_text === '待发放' || row.statusText === '待发放'
        },
        canRevoke(row) {
            return row.status == 0
        },

        // 发放
        async giveOut(row) {
            try {
                await this.$confirm(`确认发放红包？`, '提示', { type: 'warning' })
            } catch (_) { return }

            this.$set(row, '_giving', true)
            try {
                await giveOutRedPacket(String(row.id))
                this.$message.success('发放成功')
                await this.fetchList()
            } catch (e) {
                this.$message.error(e.message || '发放失败')
            } finally {
                this.$set(row, '_giving', false)
            }
        },

        // 撤回
        async revoke(row) {
            try {
                await this.$confirm(`确认撤回红包 ${row.red_packet_id}？撤回后会走退款逻辑。`, '提示', { type: 'warning' })
            } catch (_) { return }

            this.$set(row, '_revoking', true)
            try {
                const res = await revokeRedPacket(Number(row.red_packet_id))
                const data = res.data || res
                this.$message.success((data && data.remark) ? data.remark : '撤回成功')
                await this.fetchList()
            } catch (e) {
                this.$message.error(e.message || '撤回失败')
            } finally {
                this.$set(row, '_revoking', false)
            }
        },

        // 详情
        async openDetail(redPacketId) {
            this.detailVisible = true
            this.detailLoading = true
            this.detailHeader = {}
            this.detailList = []
            try {
                const res = await redPacketDetail(Number(redPacketId))
                const data = res.data || res
                this.detailHeader = Array.isArray(data) ? data : {red_packet_id:redPacketId,...(data && data.stats)} || []
                this.detailList = Array.isArray(data) ? data : (data && data.items) || []
            } catch (e) {
                this.$message.error(e.message || '获取详情失败')
            } finally {
                this.detailLoading = false
            }
        },

        itemStatusText(s) {
            if (s === 0) return '未领取'
            if (s === 1) return '已领取'
            if (s === 2) return '已过期'
            return '未知'
        },
        itemStatusTag(s) {
            if (s === 0) return 'info'
            if (s === 1) return 'success'
            if (s === 2) return 'warning'
            return ''
        }
    }
}
</script>

<style scoped>
.mb12 {
    margin-bottom: 12px;
}

.mt8 {
    margin-top: 8px;
}

.card-title {
    font-weight: 600;
}

.toolbar {
    margin-bottom: 10px;
}

.detail-header {
    color: #606266;
}
</style>
